/**
 * RecordRunner：台账记录表通用引擎（纯本地版）
 * 配置驱动（window.TZ_CONFIGS[slug]）——表单/校验/localStorage 月分桶/打印/导出导入
 * 数据全部存在本机浏览器里，本文件不向任何服务器发送数据；跨设备靠导出 / 导入备份文件。
 * 约定：DOM 写入同值零写入；存档读写收口在 loadMonth/saveMonth
 */
(function () {
  'use strict';

  var CONFIGS = window.TZ_CONFIGS || {};
  var SLUG = window.TZ_CURRENT_SLUG || '';
  var CFG = CONFIGS[SLUG] || { slug: SLUG, fields: [], title: '记录表', printRows: 15 };
  var PREFIX = 'rec-' + SLUG + '-';
  /** 当前浏览的月份偏移：0=本月，-1=上月（列表/打印/下拉共用） */
  var offset = 0;
  /** 待二次确认的删除 { ym, id, at }：at = 进入确认态的时刻（用于下面的武装延迟） */
  var pendingDel = null;
  /** 确认态出现后的「武装延迟」（毫秒）：这段时间内忽略危险键的点击，挡连击/双触穿透 */
  var DEL_ARM_MS = 500;
  /** 上一次渲染的月份：一旦换月就丢弃待确认态（详见 renderList） */
  var renderedYm = null;

  /* ---------- 存档模块（收口：本地 localStorage；无任何网络请求） ---------- */

  function monthKey(slug, d) {
    return 'rec-' + slug + '-' + d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2);
  }
  function viewMonth() {
    var d = new Date();
    d.setDate(1);
    d.setMonth(d.getMonth() + offset);
    return d;
  }
  function ymOf(d) {
    return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2);
  }
  function loadMonth(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function saveMonth(key, arr) {
    try {
      localStorage.setItem(key, JSON.stringify(arr));
    } catch (e) {
      // 配额满不再静默：这是「数据就是一切」的工具里最危险的静默失败——
      // 用户以为存上了，实际没存。给出明确指引；已存的其他月份数据不受影响。
      showError('本机存储已满，这次保存没有成功。请先在右下角「备份到文件」导出，再清理旧数据后重试。');
    }
  }

  /* ---------- 站点级共享键（跨表通用） ----------
   * 单位名称、日历展开状态——一个店 / 一台设备共用的偏好，切到任意记录表都继续有效。
   * 旧版本按表存储（PREFIX+store），首次读取时自动迁移到站点级键。 */
  var SITE = 'taizhang';
  function siteGet(k) { try { return localStorage.getItem(SITE + '-' + k) || ''; } catch (e) { return ''; } }
  function siteSet(k, v) { try { localStorage.setItem(SITE + '-' + k, v); } catch (e) { } }

  /* ---------- 工具 ---------- */

  function $(id) { return document.getElementById(id); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function setText(node, s) {
    s = s == null ? '' : String(s);
    if (node && node.textContent !== s) node.textContent = s;
  }
  function today() {
    var d = new Date();
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }

  /* ---------- 表单渲染 ---------- */

  function buildForm() {
    var box = $('rec-form');
    if (!box) return;
    box.textContent = '';
    (CFG.fields || []).forEach(function (f) {
      var cell = el('div', 'tz-field');
      var lab = el('label', null, f.label || f.name);
      lab.setAttribute('for', 'f-' + f.name);
      if (f.required) lab.appendChild(el('em', 'tz-req', '*'));
      cell.appendChild(lab);

      var input;
      if (f.type === 'select') {
        input = document.createElement('select');
        input.className = 'tool-select';
        (f.options || []).forEach(function (o) {
          var op = document.createElement('option');
          op.value = o; op.textContent = o;
          input.appendChild(op);
        });
      } else if (f.type === 'textarea') {
        // 多行文本：施工内容、异常处置、意见建议等长描述字段，跨整行（制式表格的"说明栏"）
        input = document.createElement('textarea');
        input.className = 'tool-input tool-textarea';
        input.rows = f.rows || 2;
        if (f.placeholder) input.placeholder = f.placeholder;
        if (f.maxlength) input.maxLength = f.maxlength;
      } else {
        input = document.createElement('input');
        input.type = f.type === 'date' ? 'date' : 'text';
        input.className = 'tool-input';
        if (f.placeholder) input.placeholder = f.placeholder;
        if (f.maxlength) input.maxLength = f.maxlength;
      }
      if (f.type === 'textarea') cell.className += ' tz-field--full';
      input.id = 'f-' + f.name;
      input.name = f.name;
      if (f.type === 'date') input.value = today();
      cell.appendChild(input);
      box.appendChild(cell);
    });

    renderExamples();
  }

  /* ---------- 快捷示例：点一下把整条示例回填到表单 ----------
   * 契约与 tools 完全一致（类名是共享样式，不能改）：容器 .tool-examples[data-examples-visible]、
   * 按钮 .tool-example、折叠 .tool-examples-more + .tool-example--extra。
   * 示例对象以「字段名」为键，形如
   *   { label: '午餐·红外消毒柜', meal: '午餐', method: '红外消毒柜', tempdur: '120℃ 15min' }
   * 只回填内容字段，**不动日期**——「这一笔发生在哪天」该由用户自己定；select 也只在示例给了值时才改，
   * 否则会把它置成空选项（下拉没有「空」这一档）。 */

  function renderExamples() {
    var box = $('rec-examples');
    var list = CFG.examples || [];
    if (!box || !list.length) return;
    box.hidden = false;
    // 前缀不照抄 tools 的「试试」：这里用户不知道的是「点一下会**填进表单**」，
    // 把动作说明白比简短更省事（按钮上写的是场景名，连起来读就是「点一下自动填：瓶装水 / 大米 …」）
    box.innerHTML = '<span class="tool-examples-label"><svg class="tool-icon" aria-hidden="true"><use href="#i-zap"></use></svg>'
      + '点一下自动填</span>'
      + list.map(function (ex, i) {
        return '<button class="tool-example" type="button" data-ex="' + i + '">' + escHtml(ex.label || '') + '</button>';
      }).join('');

    // 超出首屏上限的收入「更多示例」：与 tools 同样「折叠不删减」，按钮仍在 DOM 里
    var limit = parseInt(box.getAttribute('data-examples-visible'), 10);
    if (isNaN(limit) || limit <= 0) limit = 6;
    if (list.length > limit) {
      var more = el('button', 'tool-examples-more', '更多示例 (' + (list.length - limit) + ')');
      more.type = 'button';
      more.addEventListener('click', function () {
        var expanded = box.classList.toggle('is-expanded');
        var all = box.querySelectorAll('.tool-example');
        for (var i = 0; i < all.length; i++) all[i].classList.toggle('tool-example--extra', i >= limit && !expanded);
        setText(more, expanded ? '收起示例' : '更多示例 (' + (list.length - limit) + ')');
      });
      box.appendChild(more);
      var btns = box.querySelectorAll('.tool-example');
      for (var j = 0; j < btns.length; j++) btns[j].classList.toggle('tool-example--extra', j >= limit);
    }

    box.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('.tool-example') : null;
      if (!btn) return;
      var ex = list[parseInt(btn.getAttribute('data-ex'), 10)];
      if (!ex) return;
      (CFG.fields || []).forEach(function (f) {
        if (f.name === 'date') return;
        var node = $('f-' + f.name);
        if (!node) return;
        var v = ex[f.name];
        if (f.type === 'select') {
          if (v != null) node.value = String(v);
        } else {
          node.value = v == null ? '' : String(v);   // 先清空再套：不残留上一个示例的字段
        }
      });
      showError('');
    });
  }

  function showError(msg) {
    var e = $('rec-error');
    if (!e) return;
    if (msg) { e.textContent = msg; e.hidden = false; }
    else { e.textContent = ''; e.hidden = true; }
  }

  function readForm() {
    // id 必须跨设备唯一：两台设备各自录入时纯时间戳可能撞上，合并去重会静默丢掉一条
    var rec = { id: String(Date.now()) + '-' + Math.random().toString(36).slice(2, 8) };
    var missing = null;
    (CFG.fields || []).forEach(function (f) {
      var node = $('f-' + f.name);
      var v = node ? String(node.value || '').trim() : '';
      if (f.required && !v && missing === null) missing = f.label || f.name;
      rec[f.name] = v;
    });
    if (missing) { showError('请填写：' + missing); return null; }
    showError('');
    return rec;
  }

  /* ---------- 月列表与进度 ---------- */

  /* ---------- 周期口径：一张表里混着日报 / 周报 / 月报 ----------
   * 默认每张表都是「日频」：进度 = 本月有记录的日期数 / 当月天数。
   * 但「日管控、周排查、月调度」这类表是三种周期混在一张表里，按天算会**两头失真**：
   *   只做了 4 次周排查 → 显示「已覆盖 4 / 30 天」，看着像几乎没填；
   *   天天记日报（30 条）→ 显示 100%，**周排查一次没做也是满分**（假绿）。
   * 配置：
   *   groupBy: 'kind',
   *   cycles:  { '日管控': 'day', '周排查': 'week', '月调度': 'month' }
   * 分母口径：day = 当月天数；week = 该月覆盖的 ISO 周数（4~5）；month = 1。
   * 未配置 cycles 的表完全走原路径，行为不变。
   */

  /** ISO 周编号（'YYYY-Www'）：周四落在哪一年的第几周，该周就属于那一年的那一周 */
  function isoWeekKey(d) {
    var t = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    t.setDate(t.getDate() - ((t.getDay() + 6) % 7) + 3);          // 移到本周四
    var firstThu = new Date(t.getFullYear(), 0, 4);
    firstThu.setDate(firstThu.getDate() - ((firstThu.getDay() + 6) % 7) + 3);
    var week = 1 + Math.round((t - firstThu) / (7 * 86400000));
    return t.getFullYear() + '-W' + ('0' + week).slice(-2);
  }

  /** 某月里某个周期口径的应做次数（分母） */
  function planUnits(cycle, y, m) {
    if (cycle === 'week') {
      var set = {};
      var days = new Date(y, m + 1, 0).getDate();
      for (var d = 1; d <= days; d++) set[isoWeekKey(new Date(y, m, d))] = 1;
      return Object.keys(set).length;
    }
    if (cycle === 'month') return 1;
    return new Date(y, m + 1, 0).getDate();
  }

  /** 本期记录里某个周期口径的已做次数（分子）：day/week 去重计数，month 只问「有没有」 */
  function coveredUnits(cycle, records) {
    var seen = {}, n = 0;
    (records || []).forEach(function (r) {
      if (!r || !r.date) return;
      var k = cycle === 'week' ? isoWeekKey(new Date(r.date + 'T00:00:00')) : r.date;
      if (seen[k]) return;
      seen[k] = 1; n++;
    });
    return cycle === 'month' ? (n ? 1 : 0) : n;
  }

  var CYCLE_WORD = { day: '天', week: '周', month: '月' };

  /**
   * 本期进度统计。
   * 返回值：text 是直接可显示的文案段；covered/plan 给进度条用（多周期时按「合计已做/合计应做」）。
   * 未配置 cycles → 与历史行为完全一致（'已覆盖 N / M 天'，grouped=false）。
   */
  function cycleStats(arr, vd) {
    var y = vd.getFullYear(), m = vd.getMonth();
    var cycles = CFG.cycles, field = CFG.groupBy;
    if (!cycles || !field) {
      var c0 = coveredUnits('day', arr);
      var p0 = planUnits('day', y, m);
      return { text: '已覆盖 ' + c0 + ' / ' + p0 + ' 天', covered: c0, plan: p0, grouped: false };
    }
    var parts = [], covered = 0, plan = 0;
    Object.keys(cycles).forEach(function (v) {
      var cyc = cycles[v];
      var mine = (arr || []).filter(function (r) { return r && String(r[field]) === v; });
      var c = coveredUnits(cyc, mine);
      var p = planUnits(cyc, y, m);
      covered += c; plan += p;
      parts.push(v + ' ' + c + '/' + p + ' ' + (CYCLE_WORD[cyc] || '次'));
    });
    return { text: parts.join(' · '), covered: covered, plan: plan, grouped: true };
  }

  /* ---------- 打印汇总行：纸质模板做不到的事 ----------
   * 表尾自动印「共 N 条 · 覆盖 M 天 · 各取值分布」——检查时一眼能看出「这个月做没做、做得匀不匀」，
   * 而下载来的 Excel 模板只能靠人自己数。
   * 配置 summaryFields: ['finding', 'method']（select 字段；按 options 顺序统计，只列出现过的值，每字段最多 5 项）。
   * 分区打印时按区内统计（日管控区 / 周排查区各印各的）。
   */
  function sectionSummary(cfg, records, cycle) {
    var list = records || [];
    var parts = ['共 ' + list.length + ' 条'];
    if (list.length) {
      var cyc = cycle || 'day';
      var n = coveredUnits(cyc, list);
      if (n) { parts.push('覆盖 ' + n + ' ' + (CYCLE_WORD[cyc] || '次')); }
    }
    (cfg.summaryFields || []).forEach(function (fname) {
      var f = (cfg.fields || []).filter(function (x) { return x.name === fname; })[0];
      if (!f || !f.options) { return; }
      var count = {};
      list.forEach(function (r) {
        var v = r && r[fname];
        if (v) { count[v] = (count[v] || 0) + 1; }
      });
      var hit = (f.options || []).filter(function (o) { return count[o]; });
      if (!hit.length) { return; }
      var shown = hit.slice(0, 5).map(function (o) { return o + ' ' + count[o]; });
      if (hit.length > 5) { shown.push('另 ' + (hit.length - 5) + ' 种'); }
      // 统计字段多于一个时加字段名，否则两个「正常 10」读者分不清对应哪一栏
      var prefix = (cfg.summaryFields || []).length > 1 ? (f.label || f.name) + '：' : '';
      parts.push(prefix + shown.join('、'));
    });
    return parts.join(' · ');
  }

  /** id → 数值：兼容旧数据（老记录是纯时间戳数字，新记录是「时间戳-随机串」） */
  function idNum(id) {
    var n = parseInt(String(id == null ? '' : id), 10);
    return isNaN(n) ? 0 : n;
  }

  function sortedRecords(arr) {
    return (arr || []).slice().sort(function (a, b) {
      return (a.date || '').localeCompare(b.date || '') || (idNum(a.id) - idNum(b.id));
    });
  }

  /**
   * 列表摘要行：配置驱动
   * 优先取 CFG.listFields；未配置则回退为「除日期外的前 4 个字段」——
   * 这样新增表零配置也可读，且绝不出现硬编码某张表字段名（历史 bug：仅消毒表可见）。
   */
  function listSummary(r) {
    var names = (CFG.listFields && CFG.listFields.length)
      ? CFG.listFields
      : (CFG.fields || []).filter(function (f) { return f.name !== 'date'; })
          .slice(0, 4).map(function (f) { return f.name; });
    var parts = [r.date || ''];
    names.forEach(function (n) { if (r[n]) parts.push(String(r[n])); });
    return parts.join(' · ');
  }

  function renderList() {
    var box = $('rec-list');
    if (!box) return;
    var vd = viewMonth();
    var ym = ymOf(vd);
    // 换月即丢弃待确认态：否则翻月回来「删除这条？」还挂在那儿，容易被顺手误点
    if (ym !== renderedYm) { pendingDel = null; renderedYm = ym; }

    var arr = sortedRecords(loadMonth(monthKey(SLUG, vd)));
    box.textContent = '';

    // 标题只报「月份 + 条数」：板块名已由页内 H2 承担，避免同屏出现两遍「已填记录」
    var listLabel = (offset === 0 ? '本月' : vd.getFullYear() + ' 年 ' + (vd.getMonth() + 1) + ' 月');
    box.appendChild(el('h3', 'tz-list-title', listLabel + ' · ' + arr.length + ' 条记录'));
    if (!arr.length) {
      box.appendChild(el('p', 'tz-empty', '该月还没有记录。'));
    } else {
      arr.forEach(function (r) {
        var row = el('div', 'tz-rec-row');
        row.appendChild(el('span', 'tz-rec-main', listSummary(r)));

        // 行尾操作区：单证按钮（仅配置了 recordDoc 的表）+ 删除。收进同一个 flex 容器，
        // 否则 space-between 会把两个按钮在行尾「均匀拉开」，看着像两个不相关的动作。
        var ops = el('span', 'tz-rec-ops');
        if (CFG.recordDoc) {
          var dbtn = el('button', 'tz-rec-doc', CFG.recordDoc.label || '出单证');
          dbtn.type = 'button';
          dbtn.setAttribute('aria-label', '为 ' + (r.date || '') + ' 记录生成' + (CFG.recordDoc.title || '单证'));
          dbtn.addEventListener('click', function () { printRecordDoc(r); });
          ops.appendChild(dbtn);
        }

        // 内联二次确认：删除不可逆且没有撤销，就地再问一次，避免误触（尤其手机上）。
        // 形态用白卡浮层（Popconfirm 范式）而不是给整行铺色：铺色会打断列表底纹、
        // 按钮又和粉色底融在一起；浮层把问句和两个按钮收进同一张卡，选择感是完整的。
        //
        // 「删除」链接在确认态保持原位（不替换、不重排）：行高与右缘不变，浮层箭头
        // 有稳定锚点；且光标就停在刚点过的链接上——再点一下＝收起浮层（开关语义），
        // 连击、双触落在原位的任何东西上都不会直接删数据。
        var confirming = pendingDel && pendingDel.ym === ym && String(pendingDel.id) === String(r.id);
        var del = el('button', 'tz-del', '删除');
        del.type = 'button';
        del.setAttribute('aria-label', '删除 ' + (r.date || '') + ' 记录');
        del.addEventListener('click', function () {
          var same = pendingDel && pendingDel.ym === ym && String(pendingDel.id) === String(r.id);
          pendingDel = same ? null : { ym: ym, id: r.id, at: Date.now() };
          renderList();
          if (!same) {
            // 焦点落在「取消」（安全项）：误点删除的人一路回车也不会删掉数据
            var c = box.querySelector('.tz-pop-actions .tool-btn');
            if (c) c.focus();
          }
        });
        ops.appendChild(del);
        row.appendChild(ops);

        if (confirming) {
          row.className += ' is-confirming';
          var pop = el('div', 'tz-pop');
          pop.appendChild(el('span', 'tz-pop-text', '删除这条记录？'));
          var acts = el('span', 'tz-pop-actions');
          var no = el('button', 'tool-btn tool-btn--sm', '取消');
          no.type = 'button';
          no.setAttribute('aria-label', '取消删除');
          no.addEventListener('click', function () { pendingDel = null; renderList(); });
          var yes = el('button', 'tool-btn tool-btn--sm tz-btn-danger', '删除');
          yes.type = 'button';
          yes.setAttribute('aria-label', '确认删除 ' + (r.date || '') + ' 记录');
          yes.addEventListener('click', function () {
            // 武装延迟：确认态刚出现的极短窗口内忽略点击，兜住布局差异下的连击/双触
            if (Date.now() - pendingDel.at < DEL_ARM_MS) return;
            var id = r.id;
            pendingDel = null;
            removeRecord(id);
          });
          acts.appendChild(no);
          acts.appendChild(yes);
          pop.appendChild(acts);
          row.appendChild(pop);
        }
        box.appendChild(row);
      });
    }

    // 确认浮层贴近视口下缘时翻到行的上方（Popconfirm 同款行为），否则会被视口截断；
    // 上方也放不下时保持原位（用户滚动即可看到）。
    // 只在「行本身在视口内」时才翻转：键盘激活离屏行的删除时，行还在折叠线以下，
    // pr.bottom > vh 恒成立，会误翻——焦点滚动把行带进视口后，浮层恰好压住行和触发链接。
    var popNode = box.querySelector('.tz-pop');
    if (popNode) {
      var pr = popNode.getBoundingClientRect();
      var rowRect = popNode.closest('.tz-rec-row').getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var rowVisible = rowRect.top < vh && rowRect.bottom > 0;
      if (rowVisible && pr.bottom > vh && pr.top > pr.height + 12) popNode.className += ' tz-pop--above';
    }

    // 进度条 + 文案 + 月份下拉同步 + 日历
    var stats = cycleStats(arr, vd);
    var prog = $('rec-progress');
    if (prog) {
      setText(prog, (offset === 0 ? '本月' : vd.getFullYear() + ' 年 ' + (vd.getMonth() + 1) + ' 月')
        + (stats.grouped ? ' ' : '') + stats.text);
    }
    var fill = $('rec-progress-bar');
    if (fill) fill.style.width = Math.round(stats.covered / stats.plan * 100) + '%';
    var next = $('m-next');
    if (next) next.disabled = offset >= 0;
    ensureMonthOption(ymOf(vd), vd);
    var sel = $('print-month');
    if (sel && sel.value !== ymOf(vd)) sel.value = ymOf(vd);
    renderCalYear(vd);
  }

  /** 月份下拉默认只列近 12 个月；向前翻越界时把当前浏览月补进下拉，避免「显示与下拉脱节」 */
  function ensureMonthOption(ym, vd) {
    var sel = $('print-month');
    if (!sel || sel.querySelector('option[value="' + ym + '"]')) return;
    var op = document.createElement('option');
    op.value = ym;
    op.textContent = vd.getFullYear() + ' 年 ' + (vd.getMonth() + 1) + ' 月';
    // 保持倒序（新→旧）：插到比它更晚的选项之前，否则追加末尾
    var before = null;
    for (var i = 0; i < sel.options.length; i++) {
      if (sel.options[i].value < ym) { before = sel.options[i]; break; }
    }
    sel.insertBefore(op, before);
  }

  /* ---------- 记录日历：紧凑热力日历（参考 ECharts 基础日历图）
   * 小方格按「当日记录条数」分 3 级色深（visualMap 式），是已填日期也是补录入口。 ---------- */

  /** 条数 → 热力级别（0 = 未填） */
  function heatLevel(n) {
    if (!n) return 0;
    return n >= 3 ? 3 : n;
  }

  /* 单个月份卡片：卡片顶部「一~日」星期横排表头，下方 7 列迷你月历。
   * 小方格按「当日记录条数」分 3 级色深（visualMap 式），是已填日期也是补录入口。 */
  function calMonthNode(md, isCurrent) {
    var y = md.getFullYear(), m = md.getMonth();
    var ym = ymOf(md);
    var node = el('div', 'tz-cal-month' + (isCurrent ? ' is-current' : ''));
    node.appendChild(el('div', 'tz-cal-title', (m + 1) + ' 月'));

    var counts = {};
    // 非日频记录（周排查 / 月调度）额外记一笔类型角标：热力色深只反映「当天有几条」，
    // 混排表里「今天有一条周排查」和「今天有一条日报」在颜色上分不出来，角标补这个信息。
    var marks = {};
    var markField = CFG.groupBy;
    var cycMap = CFG.cycles || {};
    loadMonth('rec-' + SLUG + '-' + ym).forEach(function (r) {
      if (!r || !r.date) return;
      counts[r.date] = (counts[r.date] || 0) + 1;
      var v = markField ? r[markField] : '';
      if (v && cycMap[v] && cycMap[v] !== 'day') { (marks[r.date] = marks[r.date] || {})[v] = 1; }
    });

    var grid = el('div', 'tz-cal-grid');
    // 星期横排表头（一~日）
    ['一', '二', '三', '四', '五', '六', '日'].forEach(function (w) {
      grid.appendChild(el('div', 'tz-cal-wd', w));
    });
    // 首日前补齐空格
    var lead = (new Date(y, m, 1).getDay() + 6) % 7;
    for (var i = 0; i < lead; i++) {
      grid.appendChild(el('div', 'tz-cal-day tz-cal-blank'));
    }
    var days = new Date(y, m + 1, 0).getDate();
    var todayStr = today();
    for (var d = 1; d <= days; d++) {
      var ds = y + '-' + ('0' + (m + 1)).slice(-2) + '-' + ('0' + d).slice(-2);
      var lv = heatLevel(counts[ds]);
      var cls = 'tz-cal-day'
        + (lv ? ' is-fill is-fill--' + lv : '')
        + (ds === todayStr ? ' is-today' : '')
        + (ds > todayStr ? ' is-future' : '');
      var tags = marks[ds] ? Object.keys(marks[ds]) : [];
      var cell = el('button', cls);
      cell.type = 'button';
      cell.setAttribute('aria-label', (m + 1) + '月' + d + '日'
        + (counts[ds] ? '，已填 ' + counts[ds] + ' 条' : '，未填写')
        + (tags.length ? '，含' + tags.join('、') : '')
        + '，点击选择该日期');
      if (ds > todayStr) cell.disabled = true;
      cell.appendChild(el('span', 'tz-cal-d', String(d)));
      // 角标取类型首字（日管控→日、周排查→周、月调度→月）；同日最多显示两个，多了会挤
      if (tags.length) {
        cell.appendChild(el('span', 'tz-cal-tag', tags.slice(0, 2).map(function (v) { return v.charAt(0); }).join('')));
      }
      (function (ds) {
        cell.addEventListener('click', function () {
          var di = $('f-date');
          if (di) { di.value = ds; di.focus(); }
          var hint = $('cal-hint');
          if (hint) setText(hint, '已选 ' + ds + '：在上方表单填写后点「记一笔」即可补录该天。');
        });
      })(ds);
      grid.appendChild(cell);
    }
    node.appendChild(grid);
    return node;
  }

  /* 近 6 个月视图：以浏览月为末月，向前 5 个月各一张迷你月历卡片（卡片内星期横排）。
   * 浏览月（最后一格）高亮；随翻月整体平移，格子更大更好点。 */
  var CAL_MONTHS = 6;
  function renderCalYear(vd) {
    var wrap = $('cal-wrap');
    if (!wrap) return;
    wrap.textContent = '';

    var y = vd.getFullYear(), m = vd.getMonth();
    for (var i = CAL_MONTHS - 1; i >= 0; i--) {
      var md = new Date(y, m - i, 1);
      wrap.appendChild(calMonthNode(md, i === 0));
    }

    // 色阶图例（ECharts visualMap 式「少 → 多」）：渲染进底部与说明同排的容器
    var legendBox = $('cal-legend');
    if (legendBox) {
      legendBox.textContent = '';
      legendBox.appendChild(el('span', null, '少'));
      for (var j = 1; j <= 3; j++) legendBox.appendChild(el('i', 'lv' + j));
      legendBox.appendChild(el('span', null, '多'));
    }

    var hint = $('cal-hint');
    if (hint) {
      setText(hint, '方块颜色越深表示当天记录越多；点击任意日期，上方表单的日期会自动切换，填写后点「记一笔」即可补录。');
    }
  }

  function removeRecord(id) {
    // 记录可能属于历史月份（月份导航后删除），按记录自身日期定位桶
    var rec = null;
    for (var i = 0; i < localStorage.length; i++) {
      var k = localStorage.key(i);
      if (!k || k.indexOf(PREFIX) !== 0 || !/^\d{6}$/.test(k.slice(PREFIX.length))) continue;
      var found = loadMonth(k).filter(function (r) { return r && String(r.id) === String(id); });
      if (found.length) { rec = found[0]; break; }
    }
    if (!rec || !rec.date) return;
    var key = monthKey(SLUG, new Date(rec.date + 'T00:00:00'));
    var arr = loadMonth(key).filter(function (r) { return !r || String(r.id) !== String(id); });
    saveMonth(key, arr);
    renderList();
  }

  function submitRecord() {
    var rec = readForm();
    if (!rec) return;
    var d = rec.date ? new Date(rec.date + 'T00:00:00') : new Date();
    var key = monthKey(SLUG, d);
    var arr = loadMonth(key);
    arr.push(rec);
    saveMonth(key, arr);
    // 视图跳到所记月份（补录历史日期后，列表直接落到那一天所在月）
    var now = new Date();
    offset = (d.getFullYear() - now.getFullYear()) * 12 + (d.getMonth() - now.getMonth());
    // 复位：保留日期所在视图，清空其余文本/多行项
    (CFG.fields || []).forEach(function (f) {
      if (f.type === 'text' || f.type === 'textarea') {
        var n = $('f-' + f.name);
        if (n) n.value = '';
      }
    });
    renderList();
  }

  /* ---------- 打印（单表 / 全部表；整表由配置构建） ---------- */

  /** 一个打印分区：cfg + 该区记录 + 可选 sub（分区名）/ rows（该区行数）/ signText（该区签字）/ omitField */
  function buildTableSection(sec, storeName, ymLabel, withBreak) {
    var cfg = sec.cfg;
    var records = sec.records;
    var wrap = el('div', 'ps-section');
    if (withBreak) wrap.className += ' ps-break';

    // 标题带分区名：「日管控 / 周排查 / 月调度」在监管交付里要能各自成篇、各自签字
    wrap.appendChild(el('h1', null, (cfg.title || '记录表') + (sec.sub ? '（' + sec.sub + '）' : '')));

    var head = el('div', 'ps-head');
    var left = el('span');
    left.appendChild(document.createTextNode('单位名称：'));
    left.appendChild(el('span', null, storeName || '____________'));
    head.appendChild(left);
    head.appendChild(el('span', null, ymLabel));
    wrap.appendChild(head);

    var table = el('table', 'ps-table');
    var thead = el('thead');
    var htr = el('tr');
    // 分区打印时省略分区字段本身那一列（区内它是常量，留着只是重复占宽、挤掉明细列）
    var cols = (cfg.printColumns || []).filter(function (c) {
      return !(sec.omitField && c.f === sec.omitField);
    });
    cols.forEach(function (c) { htr.appendChild(el('th', null, c.t)); });
    thead.appendChild(htr);
    table.appendChild(thead);

    var tbody = el('tbody');
    var rows = sortedRecords(records);
    var total = Math.max(rows.length, sec.rows || cfg.printRows || 15);
    for (var i = 0; i < total; i++) {
      var tr = el('tr');
      var r = rows[i] || null;
      cols.forEach(function (c) {
        var v;
        if (c.index) v = String(i + 1);
        else if (c.join) v = c.join.map(function (f) { return r ? (r[f] || '') : ''; }).filter(Boolean).join(' ');
        else v = r ? (r[c.f] || '') : '';
        tr.appendChild(el('td', null, v));
      });
      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
    wrap.appendChild(table);

    // 汇总行（表尾）：纸质模板做不到的事 —— 自动印出「共 N 条 · 覆盖 M 天 · 各取值分布」
    var sumText = sectionSummary(cfg, records, sec.cycle);
    if (sumText) {
      wrap.appendChild(el('p', 'ps-sum', (sec.sub ? '本区汇总：' : '本月汇总：') + sumText));
    }
    if (cfg.printNote) wrap.appendChild(el('p', 'ps-note', cfg.printNote));
    wrap.appendChild(el('p', 'ps-sign', sec.signText || cfg.signText || '签字____________　日期____________'));
    return wrap;
  }

  /**
   * 把「一张表 + 该月记录」展开成打印分区列表。
   * 未配置 printSections → 单个分区（与历史行为一致）；
   * 配置了 → 按该字段的 options 顺序切区，每区独立标题 / 行数 / 签字栏，并省略该字段列。
   * 配置形态：
   *   printSections: {
   *     field: 'kind',
   *     rows: { '日管控': 30, '周排查': 5, '月调度': 2 },
   *     signText: { '日管控': '食品安全员签字…', '周排查': '食品安全总监签字…', '月调度': '企业主要负责人签字…' }
   *   }
   * 为什么不按「一张表一个周期」做新表型：目前唯一的真实用户就是混排表，
   * 它要的是「同类记录聚在一起分别成篇」，而不是「换一种时间粒度」。
   */
  function sectionsOf(cfg, records) {
    var ps = cfg.printSections;
    var field = ps && (typeof ps === 'string' ? ps : ps.field);
    if (!field) { return [{ cfg: cfg, records: records || [], cycle: cfg.period || 'day' }]; }
    var f = (cfg.fields || []).filter(function (x) { return x.name === field; })[0];
    var values = (f && f.options) || [];
    return values.map(function (v) {
      return {
        cfg: cfg,
        records: (records || []).filter(function (r) { return r && r[field] === v; }),
        sub: v,
        // 汇总行的「覆盖 N 天 / N 周 / N 月」按该区自己的周期口径算
        cycle: (cfg.cycles && cfg.cycles[v]) || cfg.period || 'day',
        rows: ps.rows && ps.rows[v],
        signText: ps.signText && ps.signText[v],
        omitField: field
      };
    });
  }

  function buildSheet(sections) {
    var sheet = $('print-sheet');
    if (!sheet) return;
    sheet.textContent = '';
    var storeEl = $('rec-store');
    var storeName = (storeEl && storeEl.value.trim()) || '';
    var vd = viewMonth();
    var ymLabel = vd.getFullYear() + ' 年 ' + (vd.getMonth() + 1) + ' 月';
    sections.forEach(function (sec, i) {
      sheet.appendChild(buildTableSection(sec, storeName, ymLabel, i > 0));
    });
  }

  /** 单表打印：当前表 + 当前视图月份的本地数据（混排表按分区展开）。
   *  手机上 window.print() 不可靠（微信内置内核不响应、iOS 无 AirPrint 形同虚设），
   *  降级为导出 A4 长图（长按保存 / 发微信 / 拿去打印店）；桌面仍走原生打印。 */
  function printMonth() {
    var sections = sectionsOf(CFG, loadMonth(monthKey(SLUG, viewMonth())));
    if (isPhone()) { exportSheetImage(function () { buildSheet(sections); }, monthImageName()); return; }
    buildSheet(sections);
    window.print();
  }

  /* ---------- 跨表动作前置：按需补齐全量配置（2026-09-23 按需加载） ----------
   * 表页只随页面加载当前表的配置（footer 只渲染一个 data js）；「打印全部表 / 备份 /
   * 恢复」要遍历全部 CONFIGS——少一张就会静默丢数据（Base::navTables 同款约束），
   * 所以动作前先动态注入其余配置并等全部就绪；任一加载失败则报错中止，绝不静默跳过。
   * 清单与缓存版本来自服务端渲染的 TZ_ALL_SLUGS / TZ_DATA_VER（与页脚 data js 同一
   * 版本参数，配置更新后 dataVer 随之变化，懒加载不会命中旧缓存）。
   */
  var allCfgReady = false;
  function ensureAllConfigs(done) {
    if (allCfgReady) { done(); return; }
    var slugs = (window.TZ_ALL_SLUGS || []).filter(function (s) { return s && !CONFIGS[s]; });
    if (!slugs.length) { allCfgReady = true; done(); return; }
    var pending = slugs.length;
    var failed = [];
    slugs.forEach(function (slug) {
      var s = document.createElement('script');
      s.src = '/static/taizhang/data/' + slug + '.js?v=' + (window.TZ_DATA_VER || '');
      s.onload = function () { if (--pending === 0) settle(); };
      s.onerror = function () { failed.push(slug); if (--pending === 0) settle(); };
      (document.head || document.documentElement).appendChild(s);
    });
    function settle() {
      if (failed.length) {
        showError('跨表操作所需的 ' + failed.length + ' 张表配置加载失败（' +
          failed.slice(0, 3).join('、') + (failed.length > 3 ? ' 等' : '') +
          '），本次操作已取消，请检查网络后重试。');
        return;
      }
      allCfgReady = true;
      done();
    }
  }

  /** 全部表打印（检查场景）：逐表取本机数据，同一月份拼成一份 A4 台账 */
  function printAll() { ensureAllConfigs(printAllNow); }
  function printAllNow() {
    var ym = ymOf(viewMonth());
    var sections = [];
    Object.keys(CONFIGS).forEach(function (slug) {
      var cfg = CONFIGS[slug];
      sectionsOf(cfg, loadMonth('rec-' + slug + '-' + ym)).forEach(function (sec) { sections.push(sec); });
    });
    if (isPhone()) { exportSheetImage(function () { buildSheet(sections); }, monthImageName()); return; }
    buildSheet(sections);
    window.print();
  }

  /* ---------- 单条记录 → 正式单证（隐患整改通知单等） ----------
   * 与「整月列表打印」互补：监管与甲方场景里大量文书是「一单一签」的，
   * 需要的是「一条记录 → 一张带编号、被查方签收的正式单证」，而不是整月表格。
   * 配置驱动：data/<slug>.js 的 recordDoc 段；未配置的表不渲染按钮、不出单证。
   * 版式：标题 → 编号/日期 → 信息头 → 正文分段 → 签字栏 → 页脚说明。
   * 编号由「前缀 + 日期 + 记录 id 尾四位」拼出，同一条记录重出单号稳定不变。
   */
  function docNoOf(cfg, r) {
    var rd = cfg.recordDoc || {};
    var d = String(r.date || today()).replace(/-/g, '');
    var tail = String(r.id == null ? '' : r.id).replace(/\D/g, '').slice(-4);
    return (rd.noPrefix ? rd.noPrefix + '-' : '') + d + (tail ? '-' + tail : '');
  }

  function buildRecordDoc(cfg, r) {
    var rd = cfg.recordDoc || {};
    var wrap = el('div', 'ps-section ps-doc');
    wrap.appendChild(el('h1', 'ps-doc-title', rd.title || cfg.title || '单证'));

    var kv = el('div', 'ps-doc-kv');
    var noLine = el('div', 'ps-doc-no');
    noLine.appendChild(el('span', null, (rd.noLabel || '编号') + '：'));
    noLine.appendChild(el('span', 'ps-doc-no-v', docNoOf(cfg, r)));
    kv.appendChild(noLine);
    kv.appendChild(el('div', 'ps-doc-date', '日期：' + (r.date || '')));
    wrap.appendChild(kv);

    // 信息头：左栏条目名 + 右栏值，逐行铺成两列表（比纯文本更接近制式文书）
    var head = el('table', 'ps-doc-head');
    (rd.head || []).forEach(function (h) {
      var tr = el('tr');
      tr.appendChild(el('th', null, h[0]));
      tr.appendChild(el('td', null, r[h[1]] || ''));
      head.appendChild(tr);
    });
    wrap.appendChild(head);

    (rd.body || []).forEach(function (b) {
      var sec = el('div', 'ps-doc-sec');
      sec.appendChild(el('div', 'ps-doc-label', b.label || ''));
      sec.appendChild(el('div', 'ps-doc-text', r[b.f] || ''));
      wrap.appendChild(sec);
    });

    var sign = el('div', 'ps-doc-sign');
    (rd.sign || []).forEach(function (t, i) {
      var f = (rd.signFields || [])[i];
      var col = el('div', 'ps-doc-sign-col');
      col.appendChild(el('div', 'ps-doc-sign-line', (f && r[f]) ? r[f] : ''));
      col.appendChild(el('div', 'ps-doc-sign-label', t || ''));
      sign.appendChild(col);
    });
    wrap.appendChild(sign);

    if (rd.footer) wrap.appendChild(el('p', 'ps-doc-foot', rd.footer));
    return wrap;
  }

  function renderDocSheet(node) {
    var sheet = $('print-sheet');
    if (!sheet) return;
    sheet.textContent = '';
    sheet.appendChild(node);
  }

  function printRecordDoc(r) {
    var node = buildRecordDoc(CFG, r);
    var name = ((CFG.recordDoc && CFG.recordDoc.title) || '单证') + '-' + (r.date || '') + '.png';
    if (isPhone()) { exportSheetImage(function () { renderDocSheet(node); }, name); return; }
    renderDocSheet(node);
    window.print();
  }

  /* ---------- 移动端：打印降级为导出图片 ---------- */

  function isPhone() {
    return /Mobi|Android|iPhone/i.test(navigator.userAgent);
  }

  function monthImageName() {
    var vd = viewMonth();
    return '台账-' + vd.getFullYear() + '年' + (vd.getMonth() + 1) + '月.png';
  }

  // 懒加载 vendor/html2canvas.min.js（约 40KB gz）：仅手机首次导出时下载，桌面零成本
  var h2cPromise = null;
  function loadHtml2canvas() {
    if (window.html2canvas) { return Promise.resolve(window.html2canvas); }
    if (h2cPromise) { return h2cPromise; }
    h2cPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = '/static/taizhang/vendor/html2canvas.min.js';
      s.onload = function () { resolve(window.html2canvas); };
      s.onerror = function () { h2cPromise = null; reject(new Error('html2canvas 加载失败')); };
      document.head.appendChild(s);
    });
    return h2cPromise;
  }

  /** 把已渲染的 #print-sheet 光栅化成 PNG 并弹出导出遮罩。
   *  sheet 平时 display:none（打印专用），html2canvas 画不了——临时以
   *  A4 宽度（794px @96dpi）屏外显示，画完立刻恢复原状。 */
  function exportSheetImage(buildSections, filename) {
    var sheet = $('print-sheet');
    if (!sheet) { return; }
    buildSections();
    var prevCss = sheet.style.cssText;
    sheet.style.cssText = prevCss + ';display:block;position:fixed;left:-9999px;top:0;width:794px;background:#fff;z-index:-1;';
    loadHtml2canvas().then(function (h2c) {
      return h2c(sheet, { scale: 2, backgroundColor: '#ffffff', logging: false, useCORS: true });
    }).then(function (canvas) {
      sheet.style.cssText = prevCss;
      showImgPort(canvas.toDataURL('image/png'), filename);
    }).catch(function () {
      sheet.style.cssText = prevCss;
      // 失败路径两种：vendor 加载失败（老内核/断网）、图太长超 iOS canvas 像素上限
      // （「打印全部表」多月拼一图易触发）。微信里 window.print() 无响应，
      // 静默降级会让用户以为点了没反应——给出明确提示与出路。
      showImgPortError();
    });
  }

  /** 导出失败提示：复用遮罩样式，纯文案 + 关闭 */
  function showImgPortError() {
    var old = document.getElementById('tz-imgport');
    if (old && old.parentNode) { old.parentNode.removeChild(old); }
    var wrap = document.createElement('div');
    wrap.id = 'tz-imgport';
    // CSS 全是类选择器（.tz-imgport），只设 id 规则永不命中——遮罩裸 div 沉到页面
    // 底部（2026-09-24 用户两次反馈后用真实浏览器探针定位：computed position=static）
    wrap.className = 'tz-imgport';
    wrap.setAttribute('role', 'alert');
    var tip = document.createElement('p');
    tip.className = 'tz-imgport-tip';
    tip.textContent = '图片生成失败（内容太长或浏览器受限）——可换月份减少记录，或用电脑浏览器打开本页打印。';
    var bar = document.createElement('div');
    bar.className = 'tz-imgport-bar';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'tool-btn tool-btn--primary';
    close.textContent = '知道了';
    close.addEventListener('click', function () {
      if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); }
    });
    bar.appendChild(close);
    wrap.appendChild(tip);
    wrap.appendChild(bar);
    document.body.appendChild(wrap);
  }

  /** 全屏导出遮罩：微信里 a[download] 不可靠，统一「长按图片保存」；下载按钮供可用环境用 */
  function showImgPort(dataUrl, filename) {
    var old = document.getElementById('tz-imgport');
    if (old && old.parentNode) { old.parentNode.removeChild(old); }
    var wrap = document.createElement('div');
    wrap.id = 'tz-imgport';
    wrap.className = 'tz-imgport';   // 同上：CSS 类选择器必须有 class 才命中
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-label', '台账图片已生成');
    var tip = document.createElement('p');
    tip.className = 'tz-imgport-tip';
    tip.textContent = '台账图片已生成（A4 版式）——长按图片可保存到相册或转发微信';
    var img = document.createElement('img');
    img.className = 'tz-imgport-img';
    img.src = dataUrl;
    img.alt = '当月台账 A4 版式图片';
    var bar = document.createElement('div');
    bar.className = 'tz-imgport-bar';
    var save = document.createElement('button');
    save.type = 'button';
    save.className = 'tool-btn tool-btn--primary';
    save.textContent = '下载图片';
    save.addEventListener('click', function () {
      var a = document.createElement('a');
      a.href = dataUrl;
      a.download = filename || 'taizhang.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'tool-btn';
    close.textContent = '关闭';
    close.addEventListener('click', function () {
      if (wrap.parentNode) { wrap.parentNode.removeChild(wrap); }
    });
    bar.appendChild(save);
    bar.appendChild(close);
    wrap.appendChild(tip);
    wrap.appendChild(img);
    wrap.appendChild(bar);
    document.body.appendChild(wrap);
  }

  /* ---------- 启动 ---------- */

  function buildMonthOptions() {
    var sel = $('print-month');
    if (!sel) return;
    var now = new Date();
    for (var i = 0; i < 12; i++) {
      var d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      var ym = d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2);
      var op = document.createElement('option');
      op.value = ym;
      op.textContent = d.getFullYear() + ' 年 ' + (d.getMonth() + 1) + ' 月' + (i === 0 ? '（本月）' : '');
      sel.appendChild(op);
    }
    sel.addEventListener('change', function () {
      var ym = sel.value;
      var y = parseInt(ym.slice(0, 4), 10);
      var m = parseInt(ym.slice(4), 10);
      var now2 = new Date();
      offset = (y - now2.getFullYear()) * 12 + (m - 1 - now2.getMonth());
      renderList();
    });
  }

  function init() {
    buildForm();
    buildMonthOptions();
    renderList();

    var store = $('rec-store');
    if (store) {
      var savedStore = siteGet('store');
      if (!savedStore) {
        try { savedStore = localStorage.getItem(PREFIX + 'store') || ''; } catch (e) {}
        if (savedStore) siteSet('store', savedStore);
      }
      if (savedStore) store.value = savedStore;
      store.addEventListener('input', function () { siteSet('store', store.value.trim()); });
    }
    var submit = $('rec-submit');
    if (submit) submit.addEventListener('click', submitRecord);
    // Esc 取消待确认的删除（与「取消」按钮等价）
    window.document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pendingDel) { pendingDel = null; renderList(); }
    });
    // 点浮层以外区域收起确认。只认「不在任何记录行内」的点击：
    // 行内「删除」链接有自己的开关逻辑，点别行则由那行的处理器切换过去
    document.addEventListener('click', function (ev) {
      if (!pendingDel) return;
      var t = ev.target;
      if (!(t && t.closest && t.closest('.tz-rec-row'))) { pendingDel = null; renderList(); }
    });
    var printBtn = $('print-btn');
    if (printBtn) printBtn.addEventListener('click', printMonth);
    var printAllBtn = $('print-all-btn');
    if (printAllBtn) printAllBtn.addEventListener('click', printAll);
    if (isPhone()) {
      // 手机上产出的是图片而非浏览器打印，按钮文案跟着如实（只改末尾文本节点，保留图标）
      var relabel = function (btn, txt) {
        var last = btn.childNodes[btn.childNodes.length - 1];
        if (last && last.nodeType === 3) last.textContent = txt;
      };
      relabel(printBtn, '导出台账图片');
      relabel(printAllBtn, '导出全部表图片');
    }
    var backupBtn = $('backup-btn');
    if (backupBtn) backupBtn.addEventListener('click', backupToFile);
    var importBtn = $('import-btn');
    var importFile = $('import-file');
    if (importBtn && importFile) {
      // 先清空 value：否则连续导入同一个文件不会触发 change
      importBtn.addEventListener('click', function () { importFile.value = ''; importFile.click(); });
      importFile.addEventListener('change', function () {
        if (importFile.files && importFile.files[0]) importBackup(importFile.files[0]);
      });
    }
    var mPrev = $('m-prev');
    if (mPrev) mPrev.addEventListener('click', function () { offset--; renderList(); });
    var mNext = $('m-next');
    if (mNext) mNext.addEventListener('click', function () { if (offset < 0) { offset++; renderList(); } });
    // 热力日历默认折叠：占地大、平时不看。
    // 2026-09-21 改为**不记忆展开状态**：原实现把展开态写进本机，点开过一次就永远展开
    // （用户反馈「每次进来都是展开的，想让它默认隐藏」）——现在每次进页面都从折叠态开始。
    var calWrap = $('cal-wrap');
    var calFoot = $('cal-foot');
    var calToggle = $('cal-toggle');
    if (calWrap && calToggle) {
      var setCal = function (open) {
        calWrap.hidden = !open;
        if (calFoot) calFoot.hidden = !open;   // 说明 + 图例整行跟着日历一起收起
        calToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var txt = calToggle.querySelector('.tz-cal-toggle-text');
        if (txt) txt.textContent = open ? '收起日历' : '展开日历';
      };
      setCal(false);
      calToggle.addEventListener('click', function () { setCal(calWrap.hidden); });
    }
    var expMenus = Array.prototype.slice.call(window.document.querySelectorAll('.tz-exp'));
    var expBtns = window.document.querySelectorAll('[data-export]');
    expBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        exportAs(b.getAttribute('data-export'));
        // 选完格式自动收起（侧栏 + 移动端悬浮条各有一份菜单）
        expMenus.forEach(function (m) { m.removeAttribute('open'); });
      });
    });
    // 原生 details 没有「点别处关闭」：补一个，免得菜单一直挂在页面上
    if (expMenus.length) {
      window.document.addEventListener('click', function (e) {
        expMenus.forEach(function (m) {
          if (m.hasAttribute('open') && !m.contains(e.target)) m.removeAttribute('open');
        });
      });
    }
    // 移动端悬浮条「导出图片」＝侧栏主按钮的替身：转发 click 复用同一套
    // printMonth / exportSheetImage 逻辑（isPhone 分支），零重复实现
    var mobPrint = window.document.querySelector('[data-print-mob]');
    var mainPrint = window.document.getElementById('print-btn');
    if (mobPrint && mainPrint) {
      mobPrint.addEventListener('click', function () { mainPrint.click(); });
    }
  }

  /* ---------- 导出（CSV / Excel / Word / TXT） ---------- */

  function download(filename, content, mime) {
    try {
      var blob = new Blob([content], { type: mime });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      // 下载启动后释放：否则每次导出泄漏一个 Blob URL，长会话反复导出会积压
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    } catch (e) { /* 环境不支持下载则静默 */ }
  }

  function exportRows() {
    var vd = viewMonth();
    var records = sortedRecords(loadMonth(monthKey(SLUG, vd)));
    var cols = CFG.printColumns || [];
    var head = cols.map(function (c) { return c.t; });
    var rows = records.map(function (r, i) {
      return cols.map(function (c) {
        if (c.index) return String(i + 1);
        if (c.join) return c.join.map(function (f) { return r[f] || ''; }).filter(Boolean).join(' ');
        return r[c.f] || '';
      });
    });
    return { head: head, rows: rows, ym: ymOf(vd) };
  }

  /** CSV 单元格。除 RFC 4180 的引号/逗号/换行转义外，还要防公式注入：
   *  Excel/WPS 会把以 = + @ 开头的单元格当公式执行（=HYPERLINK、=cmd|… 这类），
   *  而 - 开头的只在后面跟字母时才是公式（-5 是合法负数，不能挡，否则数值列全毁）。
   *  数据虽是用户自己填的，但可能从别处粘贴或来自导入的备份，这道防线该有。 */
  function csvField(s) {
    s = String(s);
    if (/^[=+@\t\r]/.test(s) || /^-[A-Za-z]/.test(s)) { s = "'" + s; }
    return /[",\r\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }

  /** HTML 转义：导出为 .xls/.doc 时记录值可能含 < > & 等，须转义以免破坏文档结构 */
  function escHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function htmlTable() {
    var d = exportRows();
    var h = '<table border="1" style="border-collapse:collapse;font-family:SimSun,serif;font-size:12px">';
    h += '<tr>' + d.head.map(function (t) { return '<th style="background:#f2f2f2;padding:4px 8px">' + escHtml(t) + '</th>'; }).join('') + '</tr>';
    d.rows.forEach(function (row) {
      h += '<tr>' + row.map(function (v) { return '<td style="padding:4px 8px">' + escHtml(v) + '</td>'; }).join('') + '</tr>';
    });
    return h + '</table>';
  }

  function exportAs(fmt) {
    var d = exportRows();
    var name = 'taizhang-' + SLUG + '-' + d.ym;
    if (fmt === 'csv') {
      var lines = [d.head.map(csvField).join(',')];
      d.rows.forEach(function (row) { lines.push(row.map(csvField).join(',')); });
      download(name + '.csv', '\uFEFF' + lines.join('\r\n'), 'text/csv;charset=utf-8');
    } else if (fmt === 'xls') {
      download(name + '.xls',
        '<html><head><meta charset="UTF-8"></head><body><h3>' + escHtml(CFG.title || '') + '（' + d.ym + '）</h3>' + htmlTable() + '</body></html>',
        'application/vnd.ms-excel;charset=utf-8');
    } else if (fmt === 'doc') {
      var w = '<html><head><meta charset="UTF-8"></head><body>';
      w += '<h2 style="text-align:center">' + escHtml(CFG.title || '') + '</h2>';
      w += '<p style="text-align:center;font-size:12px">' + escHtml(($('rec-store') && $('rec-store').value.trim()) || '') + '　' + d.ym + '</p>';
      w += htmlTable();
      w += '<p style="font-size:12px">' + escHtml(CFG.signText || '') + '</p></body></html>';
      download(name + '.doc', w, 'application/msword;charset=utf-8');
    } else if (fmt === 'txt') {
      var t = (CFG.title || '') + '（' + d.ym + '）\r\n';
      t += d.head.join(' | ') + '\r\n';
      d.rows.forEach(function (row) { t += row.join(' | ') + '\r\n'; });
      download(name + '.txt', t, 'text/plain;charset=utf-8');
    }
  }

  /** 汇总本机全部记录表的数据 → { slug: { ym: [记录] } }；空表不收录 */
  function collectAllTables() {
    var tables = {};
    Object.keys(CONFIGS).forEach(function (slug) {
      var prefix = 'rec-' + slug + '-';
      var months = {};
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (!k || k.indexOf(prefix) !== 0) continue;
        var ym = k.slice(prefix.length);
        if (!/^\d{6}$/.test(ym)) continue;          // store / code 等非月份键跳过
        var arr = loadMonth(k);
        if (arr.length) months[ym] = arr;
      }
      if (Object.keys(months).length) tables[slug] = months;
    });
    return tables;
  }

  function dateStamp() {
    var d = new Date();
    return d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
  }

  /* ---------- 本地文件备份 / 恢复（唯一的数据搬运通道） ---------- */

  function setFileState(text) {
    var n = $('file-state');
    if (n && n.textContent !== text) n.textContent = text;
  }

  /**
   * 按记录 id 合并一个月：只增补、不覆盖、不删除。
   * 幂等——重复导入同一个文件不会产生重复数据，也无法用旧文件回滚掉新数据。
   * 返回新增条数。
   */
  function mergeMonth(key, arr) {
    var exist = loadMonth(key);
    var seen = {};
    exist.forEach(function (r) { if (r && r.id != null) seen[String(r.id)] = 1; });
    var merged = exist.slice(), added = 0;
    (arr || []).forEach(function (r) {
      if (!r || r.id == null) return;
      var id = String(r.id);
      if (seen[id]) return;
      seen[id] = 1;
      merged.push(r);
      added++;
    });
    if (added) saveMonth(key, merged);
    return added;
  }

  /** 备份到文件：全部记录表 × 所有月份，一个 JSON。纯前端生成，数据不出本机 */
  function backupToFile() { ensureAllConfigs(backupToFileNow); }
  function backupToFileNow() {
    var tables = collectAllTables();
    var slugs = Object.keys(tables);
    if (!slugs.length) {
      setFileState('本机还没有任何记录，无需备份。');
      return;
    }
    var n = 0;
    slugs.forEach(function (s) {
      Object.keys(tables[s]).forEach(function (ym) { n += tables[s][ym].length; });
    });
    var payload = JSON.stringify({
      app: 'taizhang', version: 2, exportedAt: new Date().toISOString(), tables: tables
    }, null, 2);
    download('taizhang-all-backup-' + dateStamp() + '.json', payload, 'application/json');
    setFileState('已导出 ' + slugs.length + ' 张表、' + n + ' 条记录，请把文件保存到网盘或 U 盘。');
  }

  /**
   * 从备份文件恢复。支持两种文件：
   *   ① 新版「全部表」备份 { app, version:2, tables: { slug: { ym: [...] } } } —— 按表分派
   *   ② 旧版单表备份     { slug, months: { ym: [...] } } —— 只在当前表导入，且表名必须对得上
   */
  function importBackup(file) {
    if (!file) return;
    // 恢复要按表分派到全部 CONFIGS（可能含其它表的记录），先等全量配置就绪再读文件
    ensureAllConfigs(function () { importBackupNow(file); });
  }
  function importBackupNow(file) {
    if (!file) return;
    // 本工具的备份是一张表的 JSON，通常几十 KB；超大的几乎一定是选错了文件，
    // 直接 parse 会把页面卡死，所以先按体积拦一道
    if (file.size > 10 * 1024 * 1024) {
      setFileState('恢复失败：文件超过 10MB，不是本工具的备份文件。');
      return;
    }
    var reader = new FileReader();
    reader.onload = function () {
      var data = null;
      try { data = JSON.parse(String(reader.result)); } catch (e) { data = null; }
      if (!data || typeof data !== 'object') {
        setFileState('恢复失败：文件不是备份文件（应为 JSON）。');
        return;
      }

      // ① 新版：一个文件含全部表
      if (data.tables && typeof data.tables === 'object') {
        var added = 0, months = 0, skipped = 0, inCurrent = 0;
        Object.keys(data.tables).forEach(function (slug) {
          if (!CONFIGS[slug]) { skipped++; return; }        // 本版本没有这张表，跳过而不是乱灌
          var t = data.tables[slug];
          if (!t || typeof t !== 'object') return;
          Object.keys(t).forEach(function (ym) {
            if (!/^\d{6}$/.test(ym) || !Array.isArray(t[ym])) return;
            var n = mergeMonth('rec-' + slug + '-' + ym, t[ym]);
            if (n) { added += n; months++; }
            if (slug === SLUG) inCurrent += n;
          });
        });
        if (inCurrent) renderList();
        if (!added) {
          setFileState('没有新增记录：本机已包含该文件的全部内容。');
          return;
        }
        var msg = '已恢复 ' + added + ' 条记录，涉及 ' + months + ' 个月份';
        if (skipped) msg += '（跳过 ' + skipped + ' 张本版本没有的表）';
        setFileState(msg + '。');
        return;
      }

      // ② 旧版：单表备份。必须核对表名——8 张表都用同一套结构，导错表会被静默接受
      var m = data.months;
      if (!m || typeof m !== 'object') {
        setFileState('恢复失败：这不是备份文件。');
        return;
      }
      if (data.slug && data.slug !== SLUG) {
        var title = (CONFIGS[data.slug] && CONFIGS[data.slug].title) || data.slug;
        setFileState('恢复失败：这是「' + title + '」的备份，不能导进当前这张表。请先打开那张表再恢复。');
        return;
      }
      var a2 = 0, mo = 0;
      Object.keys(m).forEach(function (ym) {
        if (!/^\d{6}$/.test(ym) || !Array.isArray(m[ym])) return;
        var n = mergeMonth(PREFIX + ym, m[ym]);
        if (n) { a2 += n; mo++; }
      });
      if (a2) renderList();
      setFileState(a2
        ? '已恢复 ' + a2 + ' 条记录，涉及 ' + mo + ' 个月份。'
        : '没有新增记录：本机已包含该文件的全部内容。');
    };
    reader.onerror = function () { setFileState('恢复失败：文件读取出错。'); };
    reader.readAsText(file);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
